<template>
	<PopupRouterViewDetail label="Jig Detail" @hideMethod="onHidden" :isShowCopyData="false">

		<!-- APP_DETAIL_HEADER -->

		<b-card header="Jig" class="mb-3 card-max-width">
			<b-row>
				<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-code" label-cols-lg="12" label="Code" label-for="input-code" size="sm"
						:model.sync="model.code" :isRequired="true" :state="validateState('code')"
						:errorMessage="getErrorMessage(errorMessage.code, 'code')" @change="updateData"
						:isUpdatable="true" />
					<app-input-textbox id="fieldset-name" label-cols-lg="12" label="Name" label-for="input-name" size="sm"
						:model.sync="model.name" :isRequired="true" :state="validateState('name')"
						:errorMessage="getErrorMessage(errorMessage.name, 'name')" @change="updateData"
						:isUpdatable="true" />
					<app-input-textbox id="fieldset-jig-long" label-cols-lg="12" label="Long" label-for="input-jig-long"
						size="sm" :model.sync="model.jigLong" @change="updateData" :isUpdatable="true" :thousandSeparator="false"  />
					<app-input-textbox id="fieldset-height" label-cols-lg="12" label="Height" label-for="input-height"
						size="sm" :model.sync="model.height" @change="updateData" :isUpdatable="true" :thousandSeparator="false"  />
					<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark" label-for="input-remark"
						size="sm" :model.sync="model.remark" @change="updateData" :isUpdatable="true" />
					<app-input-textbox id="fieldset-wide" label-cols-lg="12" label="Wide" label-for="input-wide" size="sm"
						:model.sync="model.wide" @change="updateData" :isUpdatable="true" :thousandSeparator="false"  />
				</b-col>
				<b-col cols="12" lg="6">
				</b-col>

			</b-row>
		</b-card>

		<!-- END_APP_DETAIL_HEADER -->
		<template #modal-left-button>
			<b-button class="d-sm-none d-md-inline btn-outline-success" @click="showPopUpQr()" size="sm">Print
				QR</b-button>
		</template>

		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import Jig from '@/models/Jig/Jig';
import JigList from '@/models/Jig/JigList';
import JigFilter from '@/filters/Jig/JigFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputTextbox from '@/components/AppInputTextboxNumberCustom';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components: {
		AppInputTextbox,
		AppInputTextarea,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins: [validationMixin],
	validations: {
		model: {
			code: { required },
			name: { required },
		},
	},
	data() {
		return {
			errorMessage: {
				code: { required: "Code is Required." },
				name: { required: "Name is Required." },
			},
			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			busy: false,
			isBusy: false,
			isDataLoading: false,
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterJig: null,
			currentJigPage: 1,
			jigPageSize: 10,
			sortByJig: '',
			sortDescJig: '',
			isShowPopupConfirmation: false,
			isDataCommited: false,
			mainRecordId: '',
		}
	},
	methods: {
		showPopUpQr: function () {

		},
		getJig: async function (id) {
			this.isBusy = true;
			Jig.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadJig = true;
			this.filterJig.id = this.modelId;
			Jig.downloadDataDetail(this, this.filterJig).then(result => {
				this.isDownloadJig = false;
			}).catch(error => { this.isDownloadJig = false; })
		},
		getJigs: async function (input) {
			let filter = new JigFilter();
			if (input != undefined) {
				filter.Code = input;
			}
			this.isJigComboLoading = true;
			Jig.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.jigs = result.data
					}
					this.isJigComboLoading = false;
				})
				.catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.jigInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch();
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						Jig.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'jigindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						Jig.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'jigindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					Jig.updateDataDetail(this, model, id)
						.catch((error) => {
							this.getJig(id);
						});
				}
			});
		},
		onHidden() {
			this.getJigs();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false;
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
			}
		},
	},
	beforeMount() {
		this.filterJig = new JigFilter();
	},
	async mounted() {
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getJig(id);
			} else {
				this.modelId = id;
				this.getJig(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function () {
				if (this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch: {
	},
}
</script>
